<div class="col-12 table-container">
  <table class="table table-striped table-bordered" id="gbd" aria-describedby="pending-items-table">
    <thead>
      <tr>
        <th scope="col">S. No</th>
        <th *ngFor="let column of columns" scope="col">{{ column.name }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let d of data; let i = index">
        <td>{{ i + 1 }}</td>
        <td *ngFor="let column of columns">
          <ng-container *ngIf="column.type === columnType.DATE; else falseBlock">
            {{ d[column.key] | date : 'dd/MM/yyyy' }}
          </ng-container>
          <ng-template #falseBlock>
            <ng-container *ngIf="column?.anchor?.link(d); else withoutAnchorBlock">
              <a [routerLink]="column.anchor.link(d)">
                {{ d[column.key] }}
              </a>
            </ng-container>
            <ng-template #withoutAnchorBlock>
              <span>
                {{ column.build(d) }}
              </span>
            </ng-template>
          </ng-template>
        </td>
      </tr>
      <tr *ngIf="!data || data.length === 0">
        <td class="no-rows-to-display" [attr.colspan]="columns.length + 1">No Rows To Display</td>
      </tr>
    </tbody>
  </table>
</div>
